export type TeacherCorrectionTool = "select" | "pen" | "rectangle" | "text";

export type PenStroke = {
  id: string;
  tool: "pen";
  points: { x: number; y: number }[];
  color: string;
  strokeWidth: number;
};

export type RectangleShape = {
  id: string;
  tool: "rectangle";
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
  strokeWidth: number;
};

export type TextAnnotation = {
  id: string;
  tool: "text";
  x: number;
  y: number;
  text: string;
  color: string;
  fontSize: number;
  width?: number;
  height?: number;
};

export type TeacherAnnotation = PenStroke | RectangleShape | TextAnnotation;

/** Logical annotation space = export canvas pixels (same aspect as natural image, capped). */
export type TeacherCorrectionPayload = {
  version: 2;
  canvasWidth: number;
  canvasHeight: number;
  annotations: TeacherAnnotation[];
};

export function createAnnotationId(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;
}
